var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pr" },
    [
      _c(
        "span",
        {
          staticClass:
            "yxtbiz-joinlib_selectmask pa z-19 hand nowrap ellipsis bg-white",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.selectHandle.apply(null, arguments)
            },
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.selectLabel[0])),
          _c("yxtbiz-user-name", { attrs: { name: _vm.selectLabel[1] } }),
          _vm._v(_vm._s(_vm.selectLabel[2]) + "\n  "),
        ],
        1
      ),
      _c(
        "yxtf-select",
        {
          ref: "select",
          staticClass: "width-percent-100",
          attrs: { "popper-class": "yxtbiz-joinlib_selectpop" },
          on: { change: _vm.selectChange },
          model: {
            value: _vm.selectId,
            callback: function ($$v) {
              _vm.selectId = $$v
            },
            expression: "selectId",
          },
        },
        [
          _c("Search", {
            ref: "search",
            attrs: { slot: "fixed-header", readonly: _vm.loading },
            on: { search: _vm.search },
            slot: "fixed-header",
          }),
          _c("DataEmpty", {
            attrs: { slot: "empty", loading: _vm.loading },
            slot: "empty",
          }),
          _vm._l(_vm.list, function (item) {
            return _c(
              "yxtf-option",
              {
                key: item.id,
                staticClass: "yxtbiz-joinlib_flex yxtbiz-joinlib_flexcenter",
                attrs: { label: item.label, value: item.id },
              },
              [
                _c("yxtf-svg", {
                  attrs: {
                    width: "20px",
                    height: "20px",
                    "remote-url": _vm.svgUrl,
                    "icon-class": "knglib-default",
                  },
                }),
                _c("div", { staticClass: "yxtbiz-joinlib_flex1 pr" }, [
                  _c("i", [_vm._v("  ")]),
                  _c(
                    "label",
                    { staticClass: "pa nowrap ellipsis" },
                    [
                      _vm._v(_vm._s(item.labels[0])),
                      _c("yxtbiz-user-name", {
                        attrs: { name: item.labels[1] },
                      }),
                      _vm._v(_vm._s(item.labels[2])),
                    ],
                    1
                  ),
                ]),
              ],
              1
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }